import { createStore, applyMiddleware, compose as defaultCompose } from 'redux'
import createReducers from './reducers'
import { routerMiddleware } from 'react-router-redux'
import authMiddleware from './auth/authMiddleware'
import { nprogressMiddleware } from 'redux-nprogress';
import createSagaMiddleware from 'redux-saga'
import sagas from "./saga"
import editorMiddleware from './modules/vegetation/middleware/editorMiddleware'

let _store = null;

export function injectAsyncReducer(store, name, asyncReducer) {
    store.asyncReducers[name] = asyncReducer;
    store.replaceReducer(createReducers(store.asyncReducers));
}

export const getStore = () => (_store);

export default function(history) {

    // Build the middleware for intercepting and dispatching navigation actions
    const sagaMiddleware = createSagaMiddleware()
    const middleware = routerMiddleware(history)

    let compose = defaultCompose
    /* global __REDUX_DEVTOOLS_EXTENSION_COMPOSE__:false */
    //if (process.env.NODE_ENV !== 'production' && typeof __REDUX_DEVTOOLS_EXTENSION_COMPOSE__ === 'function') {
    if ( typeof __REDUX_DEVTOOLS_EXTENSION_COMPOSE__ === 'function') {
        // in development mode, if you install the Redux Devtools extension (see https://github.com/zalmoxisus/redux-devtools-extension)
        // then this will connect to the dev tools and allow you to inspect Redux state
        compose = __REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    }

    const rootReducer = createReducers();
    const middlewares = compose(applyMiddleware(
        middleware,
        nprogressMiddleware(),
        authMiddleware,
        sagaMiddleware,
        editorMiddleware)
    );

    // Create Redux store with initial state, if specified
    _store = createStore(rootReducer, {}, middlewares)
    _store.asyncReducers = {};

    sagaMiddleware.run(sagas)

    if (module.hot && process.env.NODE_ENV === 'development') {
        module.hot.accept('./reducers/index', () => {
            const createReducers = require('./reducers/index')
            const rootReducer = createReducers(_store.asyncReducers)
            _store.replaceReducer(rootReducer)
        })
    }

    return _store
}



// WEBPACK FOOTER //
// ./src/store.js